import { render, staticRenderFns } from "./ProgressBarStep.vue?vue&type=template&id=38ca0d8b&scoped=true&"
import script from "./ProgressBarStep.vue?vue&type=script&lang=js&"
export * from "./ProgressBarStep.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBarStep.vue?vue&type=style&index=0&id=38ca0d8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca0d8b",
  null
  
)

export default component.exports